<template>
  <!-- <div class="c-main-content c-content-bg" :style="{ 'width': widthPX + 'px' ,'height': heightPX + 'px' }" > -->
  <div id="cMainContent" class="c-main-content c-content-bg" :style="{'width': widthPX + 'px'}" >
    <leftMenu></leftMenu>
    <centerContent></centerContent>
    <rightMenu v-if="(showRightMenu)"></rightMenu>
    <!-- <rightMenu v-if="(unfold_AllSc[selectedBettype.sprtId]!=undefined && unfold_AllSc[selectedBettype.sprtId][selectedBettype.tmpltId]!=undefined && !unfold_AllSc[selectedBettype.sprtId][selectedBettype.tmpltId])"></rightMenu> -->

  </div>
</template>
<script>
import leftMenu from '../contentsLeft/leftBar'
import centerContent from './centerContent'
import rightMenu from '../contentsRight/index'
import EventBus from '../../../events/event-bus'
import allBetMixin from "@/vue/mixins/allBet";
// import contentsRight from '../contentsRight/index'

import {
  mapGetters
} from 'vuex'

export default {
  mixins: [allBetMixin],
  components: {
    leftMenu,
    centerContent,
    rightMenu,
    // contentsRight,

  },
  computed: {
    ...mapGetters([
      'betLang',
      'selectedBettype',
      'resizeWHeight',
      'unfold_AllSc',
      'miniNormal',
      'frameWidthHeight'
    ]),
    heightPX: function () {
        return this.$store.getters.frameWidthHeight.height.currentHeight
    },
  },
  watch: {
    'selectedBettype': {
      handler(val, oldVal) {
        if(val!=null) {
          var sprt = this.selectedBettype.sprtId
          var tmp = this.selectedBettype.tmpltId
          
          if((sprt=='N1' && tmp!='1') || sprt!='N1'){
            this.showRightMenu = true
          }else if(sprt=='N1' && tmp=='1'){
            if(!_.isUndefined(this.unfold_AllSc[sprt]) && !_.isUndefined(this.unfold_AllSc[sprt][tmp])){
              this.showRightMenu = !this.unfold_AllSc[sprt][tmp]
            }
          }
        }
        
      },
      deep: true,
      immediate: true,
    },
    unfold_AllSc: {
      handler(val, oldVal) {
        if(this.selectedBettype!=null) {
          var sprt = this.selectedBettype.sprtId
          var tmp = this.selectedBettype.tmpltId
          
          if((sprt=='N1' && tmp!='1') || sprt!='N1'){
            this.showRightMenu = true
          }else if(sprt=='N1' && tmp=='1'){
            if(!_.isUndefined(val) && !_.isUndefined(val[sprt]) && !_.isUndefined(val[sprt][tmp])){
              this.showRightMenu = !val[sprt][tmp]
            }
          }
        }
        
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      // pendingFlag: false,
      timerId: null,
      pendingTimerId: null,
      timerSeconds: 10,
      widthPX: window.innerWidth+'px !important;',  //default
      baseWidth: 1440,
      showRightMenu: true,
    }
  },
  methods: {
    widthHandler(e) {
    
    }
  },
  mounted() {

  },
  beforeMount() {
  },
  created() {
    window.addEventListener("resize", this.widthHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.widthHandler);
  },
  beforeDestroy() {

  },
  updated() {

  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsMain/index.vue